<template>
  <v-container>
    <v-alert prominent class="ma-10" outlined type="error">
      <div class="text-h3">Unauthorized Access</div>
      
      <div class="text-body-1">Please contact your administrator for more information.</div>
    </v-alert>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>